import cx from 'classnames'
import React from 'react'

import Text, { TextStyles } from '@cinch/oxd-components/text/src'

import { LOADING_TEXT } from '../../constants'

import * as skeletonStyles from '../../skeleton.module.css'

interface Props {
  isPending?: boolean
  type?: TextStyles | keyof typeof TextStyles
  className?: string
}

const Title: React.FC<Props> = ({ children, isPending = false, type, className = '' }) => (
  <Text
    element="h5"
    className={cx(skeletonStyles.base, { [skeletonStyles.active]: isPending }, className)}
    type={type || TextStyles.mainTitle}
    children={isPending ? LOADING_TEXT : children}
  />
)

export default Title
